import { gql } from "@apollo/client";

export const getPayments = gql`
  query GetOfferPayments($args: OfferPaymentInput) {
    getOfferPayments(args: $args) {
      offer_payment_id
      payment_amount
      offer_payment_comment
      payment_details
      created_at
      updated_at
      offer {
        offer_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        offer_status
        payment_status
        claim_status
        created_at
        updated_at
      }
      distribute_payment
      approval_status
    }
  }
`;

export const getPayment = gql`
  query GetOfferPayment($id: ID) {
    getOfferPayment(payment_id: $id) {
      offer_payment_id
      payment_amount
      offer_payment_comment
      payment_details
      created_at
      updated_at
      offer {
        offer_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        offer_status
        payment_status
        claim_status
        created_at
        updated_at
      }
    }
  }
`;

export const getInsurerOfferDeductions = gql`
  query OfferparticipantDeductions($id: ID!, $offer_id: ID, $payment_id: ID!) {
    getOfferparticipantDeductions(
      insurer_id: $id
      offer_id: $offer_id
      payment_id: $payment_id
    )
  }
`;

export const getFleetOfferPaymentDetails = gql`
  query GetFleetOfferPaymentDetails($policyNumber: String!) {
    getFleetOfferPaymentDetails(policy_number: $policyNumber) {
      total_expected_amount
      vehicle_details {
        offerId
        expected_amount
        vehicleNumber
        policy_number
        fac_premium
        commission_amount
        total_previous_payments
        balance_due
      }
    }
  }
`;

export const getFleetOffersWithPayments = gql`
  query GetFleetOffersWithPayments($offerId: ID!) {
    getFleetOffersWithPayments(offer_id: $offerId) {
      offer_id
      rate
      commission
      commission_amount
      brokerage
      facultative_offer
      sum_insured
      fac_sum_insured
      premium
      fac_premium
      offer_status
      payment_status
      claim_status
      expiry_status
      created_at
      updated_at
      distribute_status
      offer_from
      place_it_id
      last_payment_made_status
      version
      place_it_created_by
      fleet_vehicle_numbers
      offer_cancel_reason
      classofbusiness {
        business_details
      }
      offer_detail {
        offer_details
      }
    }
  }
`;
